import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RowSelectEventArgs } from '@syncfusion/ej2-angular-grids';
import { FilterService, FreezeService, ReorderService, SortService, ToolbarService, TreeGridComponent } from '@syncfusion/ej2-angular-treegrid';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-kpitree',
  templateUrl: './kpitree.component.html',
  styleUrls: ['./kpitree.component.css'],
  providers: [FilterService,FreezeService, SortService,ToolbarService, ReorderService],
  encapsulation: ViewEncapsulation.None,

})
export class KpitreeComponent implements OnInit {
  @ViewChild(TreeGridComponent, { static: false }) treegrid: TreeGridComponent;
  toolbarOption?: string[];
  kpiorgList:any[]=[];
  selectedrecords:any[]=[];
  
  colsNonConformita:any[]=[];
  colsSegnalazioni:any[]=[];
  colsTicket:any[]=[];
  colsArkiGuest:any[]=[];

  colsRecruiting:any[]=[];
  colsArkiMan:any[]=[];
  colDocumenti:any[]=[];

  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    private globalService: GlobalService
  ) { }

  ngOnInit(): void {
   
    this.colsNonConformita = [
      { field: 'nonconformitadaassegnare',
      template:"${if(nonconformitadaassegnare)}<div class='kpiTree${nonconformitadaassegnareColor}'>${nonconformitadaassegnare}</div>${/if}", 
      headerText: 'Da assegnare', textAlign: 'Center', width: 130 },

      { field: 'nonconformitaazionidaeffettuare', 
      template:"${if(nonconformitaazionidaeffettuare)}<div class='kpiTree${nonconformitaazionidaeffettuareColor}'>${nonconformitaazionidaeffettuare}</div>${/if}", 
      headerText: 'Azioni da effettuare',textAlign: 'Center', width: 150 },
      { field: 'nonconformitadachiudere', 
      template:"${if(nonconformitadachiudere)}<div class='kpiTree${nonconformitadachiudereColor}'>${nonconformitadachiudere}</div>${/if}",    
      headerText: 'Da chiudere',textAlign: 'Center', width: 130 },
    ];
    this.colsSegnalazioni = [
      { field: 'segnalazionidaevadere',
      template:"${if(segnalazionidaevadere)}<div class='kpiTree${segnalazionidaevadereColor}'>${segnalazionidaevadere}</div>${/if}",
       headerText: 'Da evadere', textAlign: 'Center', width: 160 },
      { field: 'segnalazionidaevadere',
      template:"${if(segnalazionidaevadere30gg)}<div class='kpiTree${segnalazionidaevadere30ggColor}'>${segnalazionidaevadere30gg}</div>${/if}", 
      headerText: 'Da evadere (oltre 30 gg)', textAlign: 'Center', width: 160 },
    ];
    this.colsTicket = [
      { field: 'ticketaperti',template:"${if(ticketaperti)}<div class='kpiTree${ticketapertiColor}'>${ticketaperti}</div>${/if}", headerText: 'Aperti', textAlign: 'Center', width: 130 },
      { field: 'ticketdagestire',template:"${if(ticketdagestire)}<div class='kpiTree${ticketdagestireColor}'>${ticketdagestire}</div>${/if}", headerText: 'Da gestire', textAlign: 'Center', width: 130 },
     ]; 
    this.colsArkiGuest = [
      { field: 'arkiguestaperti',template:"${if(arkiguestaperti)}<div class='kpiTree${arkiguestapertiColor}'>${arkiguestaperti}</div>${/if}", headerText: 'In scadenza oggi', textAlign: 'Center', width: 130 },
      { field: 'arkiguestattivitadasvolgere',template:"${if(arkiguestattivitadasvolgere)}<div class='kpiTree${arkiguestattivitadasvolgereColor}'>${arkiguestattivitadasvolgere}</div>${/if}", headerText: 'In scadenza oggi', textAlign: 'Center', width: 130 },
    ];
    
    this.colDocumenti = [
      { field: 'arkidocdaarchiviare', 
      template:"${if(arkidocdaarchiviare)}<div class='kpiTree${arkidocdaarchiviareColor}'>${arkidocdaarchiviare}</div>${/if}",    
      headerText: 'Da completare', textAlign: 'Center', width: 130 },
    ];

   
    this.colsArkiMan = [
      { field: 'arkimannonpresiincarico', 
      template:"${if(arkimannonpresiincarico)}<div class='kpiTree${arkimannonpresiincaricoColor}'>${arkimannonpresiincarico}</div>${/if}",    
      headerText: 'Non presi in carico', textAlign: 'Center', width: 130 },
      { field: 'arkimanincaricogestionemanutenzioni', 
      template:"${if(arkimanincaricogestionemanutenzioni)}<div class='kpiTree${arkimanincaricogestionemanutenzioniColor}'>${arkimanincaricogestionemanutenzioni}</div>${/if}",    
      headerText: 'In carico a gest. manu.', textAlign: 'Center', width: 130 },
      { field: 'arkimanmanutentore', 
      template:"${if(arkimanmanutentore)}<div class='kpiTree${arkimanmanutentoreColor}'>${arkimanmanutentore}</div>${/if}",         
      headerText: 'In carico manutentore', textAlign: 'Center', width: 130 }
    ];
    
    
    this.toolbarOption = ['Search'];
    this.apiService.get('organizationchart/gettreeperuser2',{user_id:129}).subscribe((data) => {
      this.kpiorgList=data.Result;  // 165 resp area 129 carlo
    });
  }

  rowSelected(args: RowSelectEventArgs) {
    this.selectedrecords= (this.treegrid as TreeGridComponent).getSelectedRecords();  // Get the selected records.
   }
 
  collapsing(args): void {
    if (args.data.hasChildRecords) {
      this.collapseDeepChild(args.data); 
    }
  }
  
  public collapseDeepChild(data): void {
    let child = data.childRecords;
    if(child)
    for (let i = 0; i < child.length; i++) {
      if (child[i].hasChildRecords) {
        this.collapseDeepChild(child[i]);
        this.treegrid.collapseRow(null, child[i]); 
      }
    }
  }

}
